import {ReactComponent as CaretArrow} from "../assets/image/caret-right.svg"
import "./style/CustomButton.css";
import ToggleSwitch from "./ToggleSwitch";
import RadioButton from "./RadioButton";


export default function CustomButton({ 
  Icon, 
  label, 
  type, 
  background_color, 
  extra,
  checked,
  onChange,
  onClick
}) {
  const handleClick = () => {
    if (type === 1 && onClick) onClick();
    if (type === 3 && onChange) onChange();
  };

  return (
    <div 
      className="custom-button-component"
      style={{ background: background_color }}
      onClick={type === 2 ? undefined : handleClick}
    >
      <div style={{ display: "flex", flexDirection: "row", gap: "8px" }}>
        {Icon && <Icon className='grey-svg svg-24-24' />}
        <span>{label}</span>
      </div>

      <div style={{ display: "flex", flexDirection: "row", gap: "4px" }}>
        {extra && <span className="extra">{extra}</span>}

        {type === 1 && <CaretArrow className='white-svg svg-24-24' />}

        {type === 2 && (
          <ToggleSwitch 
            defaultChecked={checked}
            onChange={onChange}
          />
        )}

        {type === 3 && (
          <RadioButton 
            checked={checked}
            onChange={onChange}
          />
        )}
      </div>
    </div>
  );
}

